import type { Maybe } from '@vrplatform/utils';
import type { journalEntryType_enum } from '@vrplatform/graphql';

export type JournalEntryRelation =
  | 'deposit'
  | 'expense'
  | 'reservation'
  | 'recurringFee'
  | 'transfer'
  | 'payout';

export function getJournalEntryRelation(journalEntry: {
  recurringFeeId?: Maybe<string>;
  reservationId?: Maybe<string>;
  transactionId?: Maybe<string>;
  type?: Maybe<journalEntryType_enum>;
}): JournalEntryRelation | null {
  const recurringFeeId = journalEntry.recurringFeeId;
  const reservationId = journalEntry.reservationId;

  if (journalEntry.transactionId) {
    if (journalEntry.type?.includes('deposit')) return 'deposit';
    if (journalEntry.type?.includes('expense')) return 'expense';
    if (journalEntry.type?.includes('transfer')) return 'transfer';
    if (journalEntry.type?.includes('payout')) return 'payout';
  }

  if (recurringFeeId) return 'recurringFee';
  if (reservationId) return 'reservation';

  return null;
}
